import * as backend from '../backend-helpers/profile';
import {BobTVUser} from '../../local_modules/bobtvuser';

const GET_BUYXXL_PROFILE_REQUEST = 'GET_BUYXXL_PROFILE_REQUEST';
const GET_BUYXXL_PROFILE_SUCCESS = 'GET_BUYXXL_PROFILE_SUCCESS';
const GET_BUYXXL_PROFILE_FAILURE = 'GET_BUYXXL_PROFILE_FAILURE';
const CLEAR_BUYXXL_PROFILE = 'CLEAR_BUYXXL_PROFILE';

const initState = {
    user: null
};

export default function buyXXL(state = initState, action) {
    switch (action.type) {
        case GET_BUYXXL_PROFILE_SUCCESS:
            let {status, user, ...rest} = action.result;
            return {
                ...state,
                ...rest,
                user: new BobTVUser(user)
            };
        case CLEAR_BUYXXL_PROFILE:
            return {
                ...state,
                user: null
            };
        default:
            return state;
    }
}

export function clearProfile() {
    return { type: CLEAR_BUYXXL_PROFILE };
}

export function getProfile({id}) {
    return {
        types: [GET_BUYXXL_PROFILE_REQUEST, GET_BUYXXL_PROFILE_SUCCESS, GET_BUYXXL_PROFILE_FAILURE],
        promise: backend.getProfile({id})
    }
}



// WEBPACK FOOTER //
// ./src/reducers/buyXXL.js